import * as React from "react";
const SvgBackIcon = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 1L1 7L7 13", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgBackIcon;
